module.exports = __webpack_public_path__ + "static/media/Living-1.87bbdf40.webp";